var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Doughnut',{attrs:{"chart-data":_vm.configWithData,"chart-options":_vm.doughnutOptions,"css-classes":"dashboard-doughnut"}})
}
var staticRenderFns = []

export { render, staticRenderFns }